import type { PrijsfavorietenPart } from '../report';
import { fmtPct, pairShares } from '../utils';
import { PairedBars, PartLegend, type PartLabels } from './PartCompare';

/*
 * 03 — Gameplay, two-part layout: both distributions as Deel 1 / Deel 2 bar
 * pairs. Shares of each part's own players, so the bars are drawn against 100%.
 */

export function CompareGameplaySection({ previous, current }: { previous: PrijsfavorietenPart; current: PrijsfavorietenPart }) {
  const labels: PartLabels = { previous: previous.campaign.periodLabel, current: current.campaign.periodLabel };
  const short = { previous: 'D1', current: 'D2' };
  const weeks = current.weeks.length;
  // "Alle weken" reads "Alle 3 weken" in the design.
  const repeat = pairShares(previous.gameplay.repeat.rows, current.gameplay.repeat.rows).map((r) =>
    r.label === 'Alle weken' ? { ...r, label: `Alle ${weeks} weken` } : r,
  );

  return (
    <section id="gameplay" className="section">
      <div className="section-head">
        <div>
          <div className="eyebrow">03 — Gameplay</div>
          <h2>Speelgedrag per bezoeker</h2>
        </div>
      </div>

      <div className="grid-2 pf-grid-stack">
        <div className="card">
          <div className="card-head pf-card-head-wrap">
            <h3>Hoeveel games spelen bezoekers?</h3>
            <PartLegend labels={labels} />
          </div>
          <PairedBars rows={pairShares(previous.gameplay.distribution, current.gameplay.distribution)} format={fmtPct} scale={100} short={short} />
        </div>

        <div className="card">
          <div className="card-head pf-card-head-wrap">
            <h3>Spelers per aantal weken</h3>
            <PartLegend labels={labels} />
          </div>
          <PairedBars rows={repeat} format={fmtPct} scale={100} short={short} />
        </div>
      </div>
    </section>
  );
}
